<dgx-carousel-header
  [label]="label"
  [row]="row"
  [links]="links"
  [hideLinks]="row.loading || !row.canViewAll"
  [menuConfig]="menuConfig"
  [isEditing]="!row.loading && isEditing"
  [carouselLoading]="row.loading"
  [markdownDescription]="markdownDescription"
  [isEndOfCarousel]="isEndOfCarousel"
  [isBeginningOfCarousel]="isBeginningOfCarousel"
  [row]="row"
  [hideQuickEditHeader]="hideQuickEditHeader"
  [hideReorderButton]="hideReorderButton"
  (swipeTo)="swipe($event)"
></dgx-carousel-header>

<div class="carousel__swiper-wrapper">
  <swiper
    #swiper
    [slidesPerView]="customSlidesPerView ? customSlidesPerView : slidesPerView"
    [slidesPerGroup]="customSlidesPerView ? 1 : slidesPerView"
    [watchSlidesProgress]="true"
    [a11y]="{
      enabled: true,
      slideRole: 'slide',
      containerRoleDescriptionMessage: 'carousel',
      containerMessage: 'region'
    }"
    (slideChange)="updateCarousel()"
  >
    <ng-container *ngIf="!row.loading && !!tileType && !!slidesPerView">
      <ng-container
        *ngIf="isEditing && row.section.resourceType !== 'Opportunity'"
      >
        <ng-template swiperSlide let-slide [class]="row.gridClass">
          <div
            class="tile__wrapper"
            [ngClass]="{ hide: !slide.isVisible && isSliderInitialized }"
          >
            <dgx-add-tile
              [label]="row.addTileName"
              (clickTile)="addTargetResource($event)"
              data-dgat="carouselSection-1fe"
            ></dgx-add-tile>
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!row.loading">
        <ng-container
          *ngFor="let item of row.targetResources; trackBy: trackByReferenceId"
          data-dgat="flexRow-24e"
          class="carousel__item"
        >
          <ng-template swiperSlide let-slide [class]="row.gridClass">
            <div
              [ngSwitch]="tileType"
              class="tile__wrapper"
              [ngClass]="{ hide: !slide.isVisible && isSliderInitialized }"
            >
              <ng-container *ngSwitchCase="'Tag'">
                <dgx-tag-tile
                  [shouldWaitForRemoval]="false"
                  [tag]="item.reference"
                  [(targetLevel)]="item.parameter"
                  [isOwner]="!isEditing"
                  [targetAuthoring]="isEditing"
                  [hideFollowing]="isEditing"
                  [targetId]="row.section.targetId"
                  [showAddTarget]="isEditing && !item.parameter"
                  (removeFromPlan)="removeResourceFromRow(row, item)"
                  trackingLocation="Plan"
                  data-dgprop-location="Plan"
                ></dgx-tag-tile>
              </ng-container>

              <ng-container *ngSwitchCase="'Group'">
                <dgx-group-tile
                  [group]="item.reference"
                  [modifyOptionsFn]="row.modifyMenuOptionsFn"
                  data-dgat="flexRow-684"
                ></dgx-group-tile>
              </ng-container>

              <dgx-opportunity-card
                *ngSwitchCase="'Opportunity'"
                [opportunity]="item.reference"
              ></dgx-opportunity-card>

              <dgx-skill-standards-segment-card
                *ngSwitchCase="'SkillStandardsSegment'"
                [modifyOptionsFn]="row.modifyMenuOptionsFn"
                [segment]="item"
              ></dgx-skill-standards-segment-card>

              <ng-container *ngSwitchCase="'SkillStandardsSkill'">
                <dgx-tag-tile
                  [tag]="item"
                  [isSkillStandard]="true"
                  [modifyOptionsFn]="row.modifyMenuOptionsFn"
                  [(targetLevel)]="item.parameter"
                  [isOwner]="!isEditing"
                  [targetAuthoring]="isEditing"
                  [hideFollowing]="isEditing"
                  [targetId]="row.section.targetId"
                  [showAddTarget]="isEditing && !item.parameter"
                  (removeFromPlan)="removeResourceFromRow(row, item)"
                  [disableRatingsModalOpen]="true"
                  trackingLocation="SkillStandardSkills"
                  data-dgprop-location="SkillStandardSkills"
                ></dgx-tag-tile>
              </ng-container>

              <dgx-tile-launcher
                *ngSwitchCase="'Any'"
                [appendMenuToBody]="true"
                [item]="item.reference"
                [menuConfig]="row.menuConfig"
                [modifyOptionsFn]="row.modifyMenuOptionsFn"
              ></dgx-tile-launcher>

              <dgx-flex-provider-card
                *ngSwitchCase="'Provider'"
                [provider]="item.reference"
                [isEditing]="isEditing"
                [addMenuFn]="providerBubbleMenuConfigFn(row)"
              ></dgx-flex-provider-card>

              <dgx-tile-launcher
                *ngSwitchCase="
                  [
                    'Target',
                    'Pathway',
                    'Directory',
                    'UserContent',
                    'User'
                  ].includes(tileType)
                    ? tileType
                    : ''
                "
                [appendMenuToBody]="true"
                [item]="item.reference"
                [menuConfig]="row.menuConfig"
                [modifyOptionsFn]="row.modifyMenuOptionsFn"
              ></dgx-tile-launcher>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isEditing">
        <ng-container
          *ngFor="let stub of row.stubCount; trackBy: trackByStubIndex"
          data-dgat="flexRow-1f5"
        >
          <ng-template swiperSlide [class]="row.gridClass">
            <div class="tile__wrapper">
              <div
                class="tile tile--stub tile--{{
                  row.section.resourceType === 'Input' ||
                  row.section.resourceType === 'Any'
                    ? 'any'
                    : row.section.resourceType.toLowerCase()
                }}"
              ></div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="row.loading">
      <ng-container
        *ngFor="let i of [1, 2, 3, 4, 5, 6]"
        data-dgat="carousel-content-f14"
      >
        <ng-template swiperSlide>
          <div class="tile__wrapper">
            <dgx-skeleton
              type="{{
                row.section.resourceType === 'Input' ||
                row.section.resourceType === 'Any'
                  ? 'any'
                  : row.section.resourceType.toLowerCase()
              }}"
            ></dgx-skeleton>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </swiper>
</div>
